import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeProjectManagerList = (data) => {
	return {
		type: Types.STORE_PROJECT_MANAGER_LIST,
		payload: data
	};
};

export const fetchProjectManagerList =
	(params = '?userTypeList=PROJECT_MANAGER&page=0&size=1000') =>
	async (dispatch) => {
		await ApiClient.GET('userSearch', params).then((response) => {
			dispatch(storeProjectManagerList(response.data.data));
		});
	};
